import { useState, useEffect } from "react";
import { TokenVerificationLoggedin, ScreenView } from "../../utils/tokenVerify";
import { Radio } from "antd";
import PublisherReport from "./PublisherReport";
import DemandReport from "./DemandReport";
import QualityReport from "./QualityReport";
import QualityReportOld from "./QualityReportOld";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configData from "../../config/config.json";

const ReportV2 = () => {


    const [activeTab, setActiveTab] = useState('publisher-report');
    const [role, setRole] = useState('');
    const [countryListOptions, setCountryListOptions] = useState([]);
    const [publisherListOptions, setPublisherListOptions] = useState([]);

    const handleTabChange = (e) => {
        setActiveTab(e.target.value);
    };

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setRole(checkRole)

            axios
                .get(configData.SERVER_URL + "ops/getCountryList", {
                    headers: {
                        "Content-Type": "countrylication/json",
                        "x-access-token": token,
                    }
                },)
                .then(res => {
                    setCountryListOptions(res.data.data); // label/value array
                })
                .catch(() => { });


            if ((checkRole !== "admin" && checkRole !== "u_admin")) {
                axios
                    .get(configData.SERVER_URL + "pubReport/pubList", {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        }
                    },)
                    .then(res => {
                        // if (res.data?.status) {
                        setPublisherListOptions(res.data.data); // label/value array
                        // }
                    })
                    .catch(() => { });
            }


        }


    }, [])

    return (
        <>


            <div className="container_box--wrapper pt_header --wrapper-v2"
                style={{
                    height: "100vh",
                    overflowY: "auto"
                }}
            >
                <div className="title_intro">
                    <h1 className="heading">
                        Reports
                    </h1>
                </div>


                <>
                    <div className="tabs_wrapper">
                        <div className="radios_btns --radios_btns_new">
                            <Radio.Group
                                // className='--content'
                                className='radio_btn--group mb-0'
                                value={activeTab}
                                onChange={handleTabChange}
                                buttonStyle="solid"
                            >
                                <Radio.Button value="publisher-report">
                                    Publisher Report
                                </Radio.Button>
                                <Radio.Button value="demand-report">
                                    Demand Report
                                </Radio.Button>
                                {/* <Radio.Button value="quality-report-old">
                                    Quality Report Old
                                </Radio.Button> */}
                                <Radio.Button value="quality-report">
                                    Quality Report
                                </Radio.Button>
                            </Radio.Group>
                        </div>
                    </div>

                    <div style={{ opacity: activeTab === "publisher-report" ? "1" : "0", display: activeTab === "publisher-report" ? "block" : "none" }}>
                        <PublisherReport role={role} countryListOptionsViaParent={countryListOptions} publisherListOptionsViaParent={publisherListOptions} />

                    </div>

                    <div style={{ opacity: activeTab === "demand-report" ? "1" : "0", display: activeTab === "demand-report" ? "block" : "none" }}>
                        <DemandReport role={role} countryListOptionsViaParent={countryListOptions} publisherListOptionsViaParent={publisherListOptions} />

                    </div>

                    <div style={{ opacity: activeTab === "quality-report" ? "1" : "0", display: activeTab === "quality-report" ? "block" : "none" }}>
                        <QualityReport role={role} countryListOptionsViaParent={countryListOptions} publisherListOptionsViaParent={publisherListOptions} />

                    </div>

                    {/* <div style={{ opacity: activeTab === "quality-report-old" ? "1" : "0", display: activeTab === "quality-report-old" ? "block" : "none" }}>
                        <QualityReportOld role={role} countryListOptionsViaParent={countryListOptions} publisherListOptionsViaParent={publisherListOptions} />

                    </div> */}



                </>



            </div>


        </>
    );
};

export default ReportV2;